import axios from 'src/app-axios';
import Constants from 'src/constants';

export const questions = {
  namespaced: true,
  state: {
    orgQuestions: [],
    userSelectedAnswers: {},
  },
  getters: {
    getOrgQuestions (state) {
      return state.orgQuestions;
    },
    getUserSelectedAnswers (state) {
      return state.userSelectedAnswers;
    },
  },
  actions: {
    async fetchOrgQuestions ({ dispatch, commit }, payload) {
      const url = `api/devices/organizations/${payload.organizationExtId}/questions/${payload.userType}`;
      try {
        const response = await axios.get(url);
        commit('setOrgQuestions', response.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting your questions list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      }
    },
    onAddUserSelectedAnswers (context, answers) {
      context.commit('addUserSelectedAnswers', answers);
    },
    clearStoredQuestions (context) {
      context.commit('clearQuestionaires', []);
    },
    async sendUserSelectedAnswers ({ dispatch }, payload) {
      const url = `api/devices/questionnaire/${payload.checkInId}/answers`;
      try {
        await axios.post(url, payload.answers);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in sending your Q & A data.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
  },
  mutations: {
    setOrgQuestions (state, questions) {
      state.orgQuestions = questions;
    },
    clearQuestionaires (state, data) {
      state.orgQuestions = data;
    },
    addUserSelectedAnswers (state, answers) {
      state.userSelectedAnswers = answers;
    },
  },
};
